import { Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const SidebarItemWrapper = styled(Box)<{ active: boolean }>`
  background: ${({ active }) =>
    active ? 'rgba(255, 255, 255, 0.2)' : 'transparent'};
  cursor: pointer;
`

export const SidebarItemPendingDot = styled.div`
  width: 8px;
  height: 8px;
  background-color: white;
  border-radius: 50%;
`
